export default __webpack_public_path__ + "static/media/stockillustration.0e0c72e1.svg";